import React, { useEffect, useMemo, useState } from "react";

import { useModalContext } from "../ModalContext";
import { vanTargetColDef } from "./VanTargetColDef";
import VanTargetRowData from "./VarTargetRowData";
import LoadingSpinner from "../components/LoadingSpinner";
import { AgGridReact } from "ag-grid-react";

import api from "../axiosConfig";
import { getUser } from "../helpers";

const VanTarget = ({ open }) => {
  const user = getUser();
  const { currency } = useModalContext();

  const { loading, data: rowData } = VanTargetRowData(currency);
  const [colDefs, setColDefs] = useState([]);

  useEffect(() => {
    setColDefs(vanTargetColDef());
  }, []);

  const sideBar = {
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
        toolPanelParams: {
          suppressPivotMode: true,
          suppressPivots: true, //Hide column label
        },
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ],
    defaultToolPanel: "",
  };

  const autoGroupColumnDef = useMemo(() => {
    return {
      cellRendererParams: {
        suppressCount: true,
        totalValueGetter: (params) => {
          const isRootLevel = params.node.level === -1;
          if (isRootLevel) {
            return "Grand Total";
          }
          return `Sub Total (${params.value})`;
        },
      },
    };
  }, []);

  const onCellValueChanged = (event) => {
    console.log("editing");

    const updatedData = {
      body: {
        Warehouse: event.data.Warehouse,
        Date: event.data.Date,
        Van: event.data.Van,
        Channel: event.data.Channel,
        correction_value: event.newValue,
        page: "vantargets",
        user: user,
      },
    };

    api
      .post("/api/van/targetsupdate", updatedData)
      .then((response) => {
        // setLoading(false);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
        // setError(error);
        // setLoading(false);
      });
  };

  const onRowClicked = (params) => {
    if (params.node.group) {
      params.node.setExpanded(!params.node.expanded);
    }
  };

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner">
            <LoadingSpinner />
          </div>
        </div>
      )}
      <div
        className="ag-table-container"
        style={{ marginLeft: open ? "240px" : "0px" }}
      >
        <div
          className="ag-theme-quartz"
          style={{
            width: "100%",
            height: "calc(100dvh - 190px)",
            fontSize: "12px",
          }}
        >
          <AgGridReact
            rowData={rowData}
            columnDefs={colDefs}
            sideBar={sideBar}
            autoGroupColumnDef={autoGroupColumnDef}
            onCellValueChanged={onCellValueChanged}
            groupDisplayType="SingleColumn"
            // showOpenedGroup={true}
            // groupHideOpenParents={true}
            // groupDefaultExpanded={-1}
            groupSuppressAutoColumn={true}
            onRowClicked={onRowClicked}
            suppressAggFuncInHeader={true}
            grandTotalRow={"top"}
          />
        </div>
      </div>
    </>
  );
};

export default VanTarget;
